<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row class="row" v-if="!loading">
            <b-col cols="12">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="categoria.name" />
            </b-col>
            <b-col cols="12" class="mb-3">
                <FormInput label="Precio" type="decimal" name="precio" id="precio" rules="required" v-model="categoria.precio" class="mb-0" />
                <ImporteConGd 
                    :gd_taquilla="gd_taquilla"
                    :gd_online="gd_online"
                    :importe="categoria.precio" 
                    id="importe-con-gd"
                />
            </b-col>
            <b-col v-if="indumentarias" cols="12" class="mb-3">
                <label>Indumentarias</label>
                <ValidationProvider name="indumentarias" id="indumentarias" rules="" v-slot="{ errors }">
                    <multiselect
                        role="button"
                        v-model="categoria.indumentariasSelect"
                        id="indumentarias"
                        placeholder="Indumentarias"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :max-height="150"
                        :multiple="true" 
                        label="nombre"
                        track-by="id" 
                        :options="indumentarias"
                        style="position: relative; z-index: 9999;"
                    >
                        <template slot="option" slot-scope="{option}">
                            <div class="option__desc"><span class="option__title">{{ option.nombre }}</span> - <span class="option__small">{{ option.precio | formatear_precio }}</span></div>
                        </template>
                    </multiselect>
                    <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col v-if="categoria.indumentariasSelect && categoria.indumentariasSelect.length > 0" cols="12" class="mt-3">
                <FormInput label="Observación indumentarias" type="text" name="observacion_indumentarias" id="observacion_indumentarias" rules="" v-model="categoria.observacion_indumentarias" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormPrecioPlazosComponent :data="categoria"/>
            </b-col>            
            <b-col v-if="representantes" cols="12" class="mb-3 mt-3">
                <label>Representantes</label>
                <multiselect
                    v-model="categoria.representante"
                    id="representantes"
                    placeholder="Representantes"
                    label="name"
                    track-by="id"
                    :options="representantes"
                />
            </b-col>
            <b-col cols="4">
                <div class="custom-control custom-check mb-3 mt-3">
                    <input class="custom-control-input" type="checkbox" v-model="categoria.taquilla" id="taquilla"/>
                    <label class="custom-control-label pt-1" for="taquilla">Activar precio en taquilla</label>
                </div>
            </b-col>
            <b-col cols="8">
                <div class="custom-control custom-check mb-3 mt-3">
                    <input class="custom-control-input" type="checkbox" v-model="categoria.online" id="online"/>
                    <label class="custom-control-label pt-1" for="online">Activar precio en online</label>
                </div>
            </b-col>
            <b-col cols="12" class="mt-3 d-flex justify-content-between align-items-center">
                <Button type="submit" name="button" data-cy="guardar-plazos" :disabled="loading">GUARDAR</Button>
            </b-col>
        </b-row>
        <LoaderComponent v-else/>
    </ValidationObserver>
</template>

<script>
    import ImporteConGd from "@/components/backend/components/ImporteConGd";
    import FormPrecioPlazosComponent from "../../plazos/FormPrecioPlazosComponent.vue";

    export default {
        props: ['categoria'],
        data() {
            return {
                indumentarias: null,
                loading: false,
                gd_online: this.$store.getters.getGd['venta_bases_online'],
                gd_taquilla: this.$store.getters.getGd['venta_bases_fisica'],
                representantes: [],
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardar();
                }
            },
            getIndumentarias() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    filters: {},
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.get-indumentarias'), params).then(res => {
                    this.indumentarias = res.data.indumentarias;
                    this.loading = false;
                });
            },
            getRepresentantes() {
                let params = {
                    lista_id: this.lista_id,
                    filters: {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.get.representantes'), params).then(res => {
                    this.representantes = res.data.representantes;
                });
            },
            guardar() {
                this.$emit('terminado');
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        created() {
            this.getIndumentarias();
            this.getRepresentantes();
        },
        components: {
            ImporteConGd, FormPrecioPlazosComponent
        }
    }
</script>
